(() => {
  const debounce = (fn, wait = 180) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const getScrollY = () =>
    window.pageYOffset || document.documentElement.scrollTop || 0;

  // Keeps the page from “jumping” while dropdown DOM updates
  const keepScrollStable = (fn) => {
    const y = getScrollY();
    fn();
    requestAnimationFrame(() => {
      window.scrollTo(0, y);
      requestAnimationFrame(() => window.scrollTo(0, y));
    });
  };

  function buildItem({ title, url, image, meta }) {
    const img = image
      ? `<img class="ke-ps__img" src="${image}" alt="" loading="lazy" width="42" height="42">`
      : "";

    const metaHtml = meta ? `<div class="ke-ps__meta">${meta}</div>` : "";

    return `
      <a class="ke-ps__item" href="${url}">
        ${img}
        <div class="ke-ps__text">
          <div class="ke-ps__title">${title}</div>
          ${metaHtml}
        </div>
      </a>
    `;
  }

  function initPredictiveSearch(form) {
    const input =
      form.querySelector(".js-ps-input") ||
      form.querySelector(".header__desktop-search-input");

    const dropdown =
      form.querySelector(".js-ps-dropdown") || form.querySelector(".ke-ps");

    const resultsEl =
      form.querySelector(".js-ps-results") ||
      form.querySelector(".ke-ps__results");

    const psUrl =
      form.getAttribute("data-ke-ps-url") ||
      form.getAttribute("data-ps-url") ||
      "/search/suggest";

    if (!input || !dropdown || !resultsEl) return;

    const close = () => {
      keepScrollStable(() => {
        dropdown.hidden = true;
        input.setAttribute("aria-expanded", "false");
        resultsEl.innerHTML = "";
      });
    };

    const open = () => {
      keepScrollStable(() => {
        dropdown.hidden = false;
        input.setAttribute("aria-expanded", "true");
      });
    };

    const fetchSuggestions = async (q) => {
      const url =
        `${psUrl}.json?q=${encodeURIComponent(q)}` +
        `&resources[type]=product,collection` +
        `&resources[limit]=6` +
        `&resources[options][unavailable_products]=show` +
        `&resources[options][fields]=title,product_type,variants.title`;

      const res = await fetch(url, { headers: { Accept: "application/json" } });
      if (!res.ok) throw new Error("Predictive search failed");
      return res.json();
    };

    const render = (q, data) => {
      const products = data?.resources?.results?.products || [];
      const collections = data?.resources?.results?.collections || [];

      const items = [];

      products.forEach((p) => {
        items.push(
          buildItem({
            title: p.title,
            url: p.url,
            image: p.image,
            meta: "Product",
          })
        );
      });

      collections.forEach((c) => {
        items.push(
          buildItem({
            title: c.title,
            url: c.url,
            image: c.image,
            meta: "Collection",
          })
        );
      });

      // Footer link
      const footer = `
        <div class="ke-ps__footer">
          <a href="/search?q=${encodeURIComponent(q)}">View all results for “${q}”</a>
        </div>
      `;

      keepScrollStable(() => {
        resultsEl.innerHTML = items.join("") + footer;
      });

      open();
    };

    const onInput = debounce(async () => {
      const q = input.value.trim();

      // Stop native “jump” while typing
      keepScrollStable(() => {});

      if (q.length < 2) return close();

      try {
        const data = await fetchSuggestions(q);
        render(q, data);
      } catch (e) {
        close();
      }
    }, 180);

    input.addEventListener("input", onInput);

    input.addEventListener("focus", () => {
      // prevent focus causing a scroll jump
      keepScrollStable(() => {});
      if (resultsEl.innerHTML.trim()) open();
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });

    document.addEventListener("click", (e) => {
      if (!form.contains(e.target)) close();
    });
  }

  document
    .querySelectorAll("form[data-ke-ps-url], form[data-ps-url]")
    .forEach(initPredictiveSearch);
})();
